(function () {
    //get the formApp module
    var formApp = angular.module('formApp');

    //set the controller to the code here - the controller uses DataServices.
    formApp.controller('complaintFormController',
        ['$scope', '$http', '$controller', 'DataServices', 'UtilityServices', 'ValidationService', '$log', '$location', '$routeParams', '$filter', '$anchorScroll', '$timeout', '$rootScope', 'Constants',
            function ($scope, $http, $controller, DataServices, UtilityServices, ValidationService, $log, $location, $routeParams, $filter, $anchorScroll, $timeout, $rootScope, Constants) {

                // Inherit parent controller
                $controller('questionController', { $scope: $scope });
                $controller('documentController', { $scope: $scope });
                $controller('navigationController', { $scope: $scope });

                function process(date) {
                    var parts = date.split("/");
                    return new Date(parts[2], parts[1] - 1, parts[0]);
                }

                var optionSet;

                function prepareOptionSet() {
                    if (window.location.href.indexOf('complaint/1/complaintdetails') > -1) {
                        if (window.location.href.indexOf('DFFH') > -1) {
                            if (DataServices.responseInfo.lodgementDate == null || DataServices.isDFFHComplaint) {
                                for (var j = DataServices.configData.optionSets["organisation"].length - 1; j >= 0; j--) {
                                    if (DataServices.configData.optionSets["organisation"][j].text == 'Department of Health') {
                                        DataServices.configData.optionSets["organisation"].splice(j, 1);
                                    }
                                }
                                for (var l = DataServices.configData.optionSets["dhhsprogram"].length - 1; l >= 0; l--) {
                                    if (optionSet[l].text == 'Covid19' || optionSet[l].text == 'Health') {
                                        optionSet.splice(l, 1);
                                    }
                                }
                            }
                            else {
                                for (var n = DataServices.configData.optionSets["dhhsprogram"].length - 1; n >= 0; n--) {
                                    if (optionSet[n].text == 'Covid19' || optionSet[n].text == 'Community Health' || optionSet[n].text == 'Fairness') {
                                        optionSet.splice(n, 1);
                                    }
                                }

                            }
                        }
                        else {
                            if (DataServices.responseInfo.lodgementDate == null || DataServices.isDHComplaint) {
                                for (var k = DataServices.configData.optionSets["organisation"].length - 1; k >= 0; k--) {
                                    if ((DataServices.configData.optionSets["organisation"][k].text == 'Department of Families, Fairness and Housing')) {
                                        DataServices.configData.optionSets["organisation"].splice(k, 1);
                                    }
                                }
                                for (var m = DataServices.configData.optionSets["dhhsprogram"].length - 1; m >= 0; m--) {
                                    if (!(optionSet[m].text == 'Covid19' || optionSet[m].text == 'Health' || optionSet[m].text == 'Family Violence and Sexual Assault Services')) {
                                        optionSet.splice(m, 1);
                                    }
                                }
                            }
                            else {
                                for (var p = DataServices.configData.optionSets["dhhsprogram"].length - 1; p >= 0; p--) {
                                    if (optionSet[p].text == 'Covid19' || optionSet[p].text == 'Community Health' || optionSet[p].text == 'Fairness') {
                                        optionSet.splice(p, 1);
                                    }
                                }
                            }
                        }
                        $scope.configData.optionSets["organisation"] = DataServices.configData.optionSets["organisation"];
                    }
                }

                $scope.isDH = function () {
                    if ($location.path().indexOf('DH') > -1) {
                        $scope.IsDHVisible = true;
                        return true;
                    }
                    else {
                        $scope.IsDHVisible = false;
                        return false;
                    }
                }

                function cutoffDate() {
                    if (DataServices.responseInfo.lodgementDate == null || DataServices.isDHComplaint || DataServices.isDFFHComplaint) {
                        $scope.isAfterCutOffDate = true;
                    }
                    else {
                        $scope.isAfterCutOffDate = false;
                    }

                }

                // only get the config data if we don't have it
                DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.complaint, $scope.versionNumber, null, DataServices.isAuthenticated())
                    .then(function (data) {
                        $scope.setupTriggersAndDynamicValues();
                        $scope.setSummaryErrorFocus();

                        document.title = $scope.utility.getPageTitle($scope.navTabNum, $scope.pageUrl);
                    });

                // default access for attaching documents (NOTE: this needs to come from the user role)
                DataServices.responseInfo.access = {
                    canSaveFile: UtilityServices.isCurrentIncidentEditable(),
                    canViewFile: true,
                    canDeleteFile: UtilityServices.isCurrentIncidentEditable()
                };

                // TODO: We need to go through this to de-clutter!!
                // Complaint specific scope items
                $scope.access = DataServices.responseInfo.access;
                $scope.incidentId = DataServices.responseInfo.incidentId;
                $scope.incidentRef = DataServices.responseInfo.incidentRef;
                $scope.status = DataServices.responseInfo.status;
                $scope.statusText = DataServices.responseInfo.statusText;
                $scope.reportedDate = DataServices.responseInfo.reportedDate ? moment(DataServices.responseInfo.reportedDate).format($scope.Constants.ausDateFormat) : null;
                $scope.submittedDate = DataServices.responseInfo.submittedDate ? moment(DataServices.responseInfo.submittedDate).format($scope.Constants.ausDateFormat) : null;
                $scope.template = Constants.ConfigTemplate.complaint;
                $scope.role = DataServices.responseInfo.role;
                $scope.feedbackType = Constants.FeedbackType.Complaint;
                getOptions('dhhsprogram').then(function (result) {
                    $scope.programList = result;
                    optionSet = result
                    prepareOptionSet();
                });

                function getOptions(optionset) {
                    return $scope.utility.getOptionSetFromConfiguration(optionset, Constants.ConfigTemplate.complaint);
                }


                function validateComplaintsForm() {
                    var isValid = true;
                    var previousPageId = $scope.pageId;

                    $scope.configData.navigationTabs.forEach(function (tab) {
                        tab.pages.forEach(function (page) {
                            var pageId = tab.number + '-' + page.number;
                            $scope.pageId = pageId;
                            if (page.template !== "summary" && $scope.responses[pageId] === undefined || $scope.responses[pageId] === null) {
                                if ($scope.$eval(page.condition, null) == true) {
                                    isValid = false;
                                }
                            }
                            else {
                                var isPageValid = $scope.validatePage(tab.number, page.url, null, null, null, 'inline', true);
                                if (isPageValid === false) {
                                    isValid = false;
                                }
                            }
                        });
                    });

                    $scope.pageId = previousPageId;
                    return isValid;
                }

                $scope.onAnonymousCheckChange = function () {
                    var complainantDetails = $scope.responses["1-1"][0].complainantdetails[0];
                    if (complainantDetails.rDAnonymous === "yes") {
                        DataServices.setAnonymousDetails(complainantDetails, true);
                        $scope.utility.removeFromValidationErrors(null, $scope.pageId, null, null, null, null);
                    }
                    else {
                        DataServices.setAnonymousDetails(complainantDetails, false);
                    }
                }

                $scope.isAnonymousSelected = function () {
                    var complainantDetails = $scope.responses["1-1"][0].complainantdetails[0];
                    if (complainantDetails.rDAnonymous === "yes") {
                        return true;
                    }
                    else {
                        return false;
                    }
                }

                //person details
                $scope.getLocalCouncilFromAddressForClient = function (pIndex, sIndex) {
                    var clientdetails = $scope.responses["1-2"][0].clientdetails;
                    var details = clientdetails[sIndex];
                    if (details["cDAddress-lga"] === undefined) {
                        details["cDAddress-lga"] = "";
                    }
                    if (details !== undefined) {
                        var localCouncilDetails = DataServices.getLocalCouncilFromAddress(details["cDAddress-stateCode"], details["cDAddress-lga"]);
                        details["cDLocalCouncilText"] = localCouncilDetails.text;
                        details["cDLocalCouncil"] = localCouncilDetails.code;
                        return localCouncilDetails.text;
                    }
                }

                //your details/Complainant details
                $scope.getLocalCouncilFromAddress = function () {
                    var responses = $scope.responses["1-1"][0];
                    var complainantdetails = responses["complainantdetails"][0];
                    if (complainantdetails["rDAddress-lga"] === undefined) {
                        complainantdetails["rDAddress-lga"] = "";
                    }
                    if (complainantdetails !== undefined) {
                        var localCouncilDetails = DataServices.getLocalCouncilFromAddress(complainantdetails["rDAddress-stateCode"], complainantdetails["rDAddress-lga"]);
                        complainantdetails["rDLocalCouncil"] = localCouncilDetails.code;
                        complainantdetails["rDLocalCouncilText"] = localCouncilDetails.text;
                        return localCouncilDetails.text;
                    }
                }

                // Submits the feedback if there are no validation errors.
                $scope.submitFeedback = function () {
                    //Clearing the validation errors
                    $scope.validationErrors.length = 0;

                    if (validateComplaintsForm()) {
                        $scope.currentLoadSubmitMessage = "Submitting Complaint";

                        // TODO: we need a cleaner way of injecting this captcha value.                        
                        DataServices.responseInfo.captchaResponse = $scope.valueOfQuestion(null, 'cOCaptcha', 'consent', 0, 0);

                        $scope.isSaving = true;
                        cutoffDate();
                        DataServices.submitIncident($scope.feedbackType, $scope.IsDHVisible, $scope.isAfterCutOffDate)
                            .then(function (response) {
                                if (response.data && response.data.status == 2) {
                                    $scope.utility.openPopup('savedElsewhere', { lastUpdatedBy: response.data.lastUpdatedBy });
                                }
                                else {
                                    if (response.data && response.data.id) {
                                        DataServices.trackEventsWithGA('Submit action in ' + $scope.pageUrl, 'Click Submit To Manager', 'Successfully Submitted Incident');

                                        $scope.updateStatusBarInformation(response.data);

                                        $scope.goToNextPage();
                                    }
                                    else {
                                        $scope.utility.showNotification(true, 'internalError');
                                    }
                                }
                            }, function (response) {
                                $scope.utility.openPopup('errorSubmit');
                                DataServices.trackEventsWithGA('Error occured during Submiting in ' + $scope.pageUrl, 'Click Submit To Manager', 'Failed to Submit Incident');
                            })
                            .finally(function () {
                                $scope.isSaving = false;
                            });
                    }
                    else {
                        if ($scope.validationErrors !== null && $scope.validationErrors !== undefined) {
                            if ($scope.validationErrors.length > 0) {
                                var error = $scope.validationErrors[0];
                                var tabNum = error.pageNo.split("-")[0];
                                var pageNum = error.pageNo.split("-")[1];

                                ExpandErroredSections("1-2", "clientdetails");
                                var page = $scope.configData.navigationTabs[tabNum - 1].pages[pageNum - 1];
                                $scope.utility
                                    .openPopup('reviewComplaintErrors').result
                                    .then(function (data) {
                                        $scope.goToPage(tabNum, page.url);
                                    });
                            }
                            else {
                                $scope.utility
                                    .openPopup('reviewComplaintErrors');
                            }
                        }
                    }
                };

                function ExpandErroredSections(pageId, sectionName) {
                    //Expanding the error sections
                    var errorSectionIndexList = [];
                    $scope.validationErrors.forEach(function (error) {
                        if (error.pageNo === pageId && error.pageIndex === 0 && error.sectionCode === sectionName) {
                            if (errorSectionIndexList.indexOf(error.sectionIndex) === -1) {
                                errorSectionIndexList.push(error.sectionIndex);
                            }
                        }
                    });

                    if (errorSectionIndexList.length > 0) {
                        errorSectionIndexList.forEach(function (sectionIndex) {
                            $scope.responses[pageId][0][sectionName][sectionIndex].$state = "Editing";
                        });
                    }
                }

                $scope.IsOtherProgramSelected = function () {
                    return UtilityServices.getOptionSetText('dhtypeofservice', $scope.responses["1-3"][0]["serviceDetails"][0]["sPProgram_DH"]) === "Other";
                }

                $scope.IsOtherOrgSelected = function () {
                    if ($scope.responses["1-3"][0]["serviceDetails"][0] !== null
                        && $scope.responses["1-3"][0]["serviceDetails"][0] !== undefined
                        && $scope.responses["1-3"][0]["serviceDetails"][0]["sPOrgName"] !== null
                        && $scope.responses["1-3"][0]["serviceDetails"][0]["sPOrgName"] !== undefined) {
                        return $scope.responses["1-3"][0]["serviceDetails"][0]["sPOrgName"]["text"] === "Other";
                    }
                    else {
                        return false;
                    }
                }

                $scope.IsOtherOrgSelectedForDh = function () {
                    if ($scope.responses["1-3"][0]["serviceDetails"][0] !== null
                        && $scope.responses["1-3"][0]["serviceDetails"][0] !== undefined
                        && $scope.responses["1-3"][0]["serviceDetails"][0]["sPOrgName_DH"] !== null
                        && $scope.responses["1-3"][0]["serviceDetails"][0]["sPOrgName_DH"] !== undefined) {
                        return $scope.responses["1-3"][0]["serviceDetails"][0]["sPOrgName_DH"]["text"] === "Other";
                    }
                    else {
                        return false;
                    }
                }
                // Downloads the PDF
                $scope.downloadPdf = function (qCode) {

                    DataServices.trackEventsWithGA('Download PDF action in ' + $scope.pageUrl, 'Click Download PDF', 'Download Feedback PDF');
                    $scope.isButtonLoading[qCode] = true;

                    DataServices.viewComplaintsUnRegisteredPdf($scope.incidentId)
                        .then(function (response) {
                            var data = response && response.data;
                            try {
                                var file = new Blob([data], { type: "application/pdf" }, { name: DataServices.responseInfo.incidentRef });

                                //if (window.Blob && window.navigator.msSaveOrOpenBlob) {
                                //    saveAs(file, DataServices.responseInfo.incidentRef + '.pdf');
                                //}
                                saveAs(file, DataServices.responseInfo.incidentRef + '.pdf');
                            }
                            catch (e) {
                                $scope.utility.openPopup('errorDownloadPdf');
                            }
                            $scope.isButtonLoading[qCode] = false;
                        }, function () {
                            $scope.utility.openPopup('errorDownloadPdf');
                            $scope.isButtonLoading[qCode] = false;
                        });
                };

                // Updates information needed for the status bar
                $scope.updateStatusBarInformation = function (response) {

                    DataServices.responseInfo.incidentId = response.id;
                    DataServices.responseInfo.incidentRef = response.ref;
                    DataServices.responseInfo.lastUpdatedTime = response.allocatedLastUpdatedTime;
                    DataServices.responseInfo.reportedDate = response.reportedDate;
                    DataServices.responseInfo.submittedDate = response.submittedDate;
                    DataServices.responseInfo.status = response.incidentStatus;
                    DataServices.responseInfo.statusText = response.incidentStatusText;

                    // Set original response to current response as update has occurred.
                    $scope.originalResponse = angular.copy($scope.responses);

                    $scope.incidentId = DataServices.responseInfo.incidentId;
                    $scope.incidentRef = DataServices.responseInfo.incidentRef;
                    $scope.lastUpdatedTime = DataServices.responseInfo.lastUpdatedTime;
                    $scope.reportedDate = DataServices.responseInfo.reportedDate ? moment(DataServices.responseInfo.reportedDate).format($scope.Constants.ausDateFormat) : null;
                    $scope.submittedDate = DataServices.responseInfo.submittedDate ? moment(DataServices.responseInfo.submittedDate).format($scope.Constants.ausDateFormat) : null;
                    $scope.status = DataServices.responseInfo.status;
                    $scope.statusText = DataServices.responseInfo.statusText;
                    $scope.role = DataServices.responseInfo.role;

                    if (response.formConfig && response.formConfig.configData) {
                        // Explicitly set config data
                        DataServices.configData = response.formConfig.configData;
                        $scope.configData = response.formConfig.configData;

                        DataServices.pushConfigData(response.formConfig.configData, Constants.ConfigTemplate.complaint, response.formConfig.versionNumber, response.formConfig.role);
                    }
                }

                // ******************************************
                // NOTE: All local functions below this line.
                // ******************************************

                // Performs the actual save for registered users
                var saveIncidentRegisteredUser = function (feedbackType) {

                    if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline', null, true)) {

                        $scope.isSaving = true;
                        DataServices.saveIncidentRegisteredUser(feedbackType)
                            .then(
                                function (response) {
                                    $scope.isSaving = false;

                                    if (response.data && response.data.status == 2) {
                                        $scope.utility.openPopup('savedElsewhere',
                                            { lastUpdatedBy: response.data.lastUpdatedBy });
                                    }
                                    else {
                                        if (response.data && response.data.id) {
                                            DataServices.trackEventsWithGA('Save action in ' + $scope.pageUrl, 'Click Save Incident Registered User', 'Successfully Saved Incident');

                                            $scope.updateStatusBarInformation(response.data);
                                            $scope.utility.openPopup('successSaveComplaint',
                                                {
                                                    incidentRef: response.data.ref,
                                                    oldStatusText: $scope.statusText,
                                                    statusText: "Save Sucessfully"
                                                    //response.data.incidentStatusText
                                                }).closed.then(function () {
                                                    $rootScope.allowFormNavigation = false;
                                                    $scope.returnToComplaints();
                                                });
                                        } else {
                                            $scope.utility.showNotification(true, 'internalError');
                                        }
                                    }
                                },
                                function (response) {
                                    $scope.isSaving = false;
                                    $scope.utility.openPopup('errorSave');
                                    DataServices.trackEventsWithGA('Error occured during Save in ' + $scope.pageUrl,
                                        'Click Save Incident Registered User',
                                        'Failed to Save Incident');
                                }
                            );
                    }
                }

                $scope.callCancelFollowUp = function () {
                    $scope.cancel();
                };

                // ******************************************
                // NOTE: All local functions below this line.
                // ******************************************

                $scope.cancel = function () {
                    // function to call on window close on Incident form
                    if (DataServices.isFullyRegisteredUser()) {

                        if ($scope.isPageEditable === false) {
                            $scope.returnToComplaints();
                        }
                        else {
                            if (!angular.equals($scope.originalResponse, $scope.responses)) {
                                // for registered users
                                // display a confirmation message
                                $scope.utility.openPopup('warnUserBeforeCancelRegisteredUser').result
                                    .then(function (data) {
                                        if (data.result == "thirdButtonClick") {
                                            // On Yes, Save the changes
                                            $rootScope.allowFormNavigation = false;
                                            saveIncidentRegisteredUser($scope.feedbackType);
                                        }
                                        else {
                                            $scope.returnToComplaints();
                                        }
                                    });
                            }
                            else {
                                $scope.returnToComplaints();
                            }
                        }

                    }
                    else {
                        // for direct users 
                        // If user chose Yes, current page is closed and landing page is displayed.
                        // If user selects 'No', system stays on the current page.
                        $scope.utility.openPopup('warnUserBeforeCancel').result.then(
                            function (result) {
                                // On Yes go to landing page
                                $rootScope.allowFormNavigation = false;
                                $scope.returnToComplaints();
                            });
                    }
                }


                $scope.returnToComplaints = function () {
                    $location.path(Constants.Url.landing);
                }
            }]);
}());